export default __webpack_public_path__ + "static/media/113.94ce7cb8.webp";